"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FlatPropertyBuilderModule = /** @class */ (function () {
    function FlatPropertyBuilderModule() {
    }
    return FlatPropertyBuilderModule;
}());
exports.FlatPropertyBuilderModule = FlatPropertyBuilderModule;
